var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('document', 'documentElement');



//////////////////
// WEBPACK FOOTER
// ./~/react-avatar/~/core-js/internals/html.js
// module id = 2209
// module chunks = 0